const danhSachLogTrongAppPaging = state => state.danhSachLogTrongAppPaging;

export default {
  danhSachLogTrongAppPaging,
};
